module.exports = __webpack_public_path__ + "img/honor_13.bd66083c.png";